import React from 'react';

const Check = () => {

  return (
    <>
        <svg xmlns="http://www.w3.org/2000/svg" version="1.1" x="0px" y="0px" viewBox="0 0 100 125"><g transform="translate(0,-952.36218)"><path d="m 70.920166,981.34103 a 6.0006,6.0006 0 0 0 -4.125,1.8125 c -9.36168,9.382 -16.579,17.24867 -25.15625,26.03127 l -8.71875,-7.375 a 6.0006,6.0006 0 1 0 -7.75,9.1562 l 13,11 a 6.0006,6.0006 0 0 0 8.125,-0.3437 c 10.7906,-10.8138 18.45728,-19.4345 29,-29.99997 a 6.0006,6.0006 0 0 0 -4.375,-10.2813 z" marker="none"/></g></svg>
    </>
  );
};

export default Check;
